import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from 'react';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Providers } from './providers';
import { PersistenceBridge } from './PersistenceBridge';
import { routes } from './routes';
import { RouteLoader } from '@/components/RouteLoader';
import { ShortcutsHelpProvider } from '@/features/mattress-configurator/components/ShortcutsHelpProvider';
function AnimatedRoutes() {
    const element = useRoutes(routes);
    return (_jsx(AnimatePresence, { mode: "wait", initial: false, children: _jsx(motion.div, { initial: { opacity: 0, y: 6 }, animate: { opacity: 1, y: 0 }, exit: { opacity: 0, y: -4 }, transition: { duration: 0.24, ease: [0.2, 0.7, 0.2, 1] }, className: "min-h-screen", children: _jsx(Suspense, { fallback: _jsx(RouteLoader, {}), children: element }) }, location.pathname) }));
}
export function App() {
    return (_jsxs(Providers, { children: [_jsx(PersistenceBridge, {}), _jsx(BrowserRouter, { children: _jsx(ShortcutsHelpProvider, { children: _jsx(AnimatedRoutes, {}) }) })] }));
}
